import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationsProvider } from './contexts/NotificationsContextType';
import { DocumentsProvider } from './contexts/DocumentsContext';
import './App.css';
import { preloadLotImages } from './utils/getLotImage';
import { ProfileProvider } from './contexts/ProfileContext';
import { AcheteurProfileProvider } from './contexts/AcheteurProfileContext';
import { ToastProvider } from './composants/Toast';

// Layouts et routes
import MainLayout from './Layout/MainLayout';
import PrivateRoute from './composants/PrivateRoute/PrivateRoute';
import RequireContractPrestataire from './composants/PrivateRoute/RequireContractPrestataire';

// Pages publiques
import Accueil from './pages/Accueil/Accueil';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
// Pages legales / chartes : rendu dynamique unique lisant pages_du_site (contenu edite en BO).
// Remplace les anciens composants en dur (Securite, MentionsLegales, CharteRSE, CharteDeontologie,
// CharteAchatsDurables) desormais supprimes ; le slug ci-dessous mappe vers la ligne pages_du_site.
import PageStatique from './pages/PageStatique/PageStatique';

// Pages privees
import Commandes from './pages/Commandes/Commandes';
// LEGACY NEUTRALISE (verif avant suppression V2) : import SuiviDeCommande from './pages/SuiviDeCommande/SuiviDeCommande';
// LEGACY NEUTRALISE : import SuiviOperation from './pages/SuiviOperation/SuiviOperation';
// LEGACY NEUTRALISE : import SuiviOperationBC from './pages/SuiviOperationBC/SuiviOperationBC';
import SuiviOperationBCV2 from './pages/SuiviOperationBCV2/SuiviOperationBCV2';
import SuiviOperationMSV2 from './pages/SuiviOperationMSV2/SuiviOperationMSV2';
// LEGACY NEUTRALISE : import SuiviOperationBCI from './pages/SuiviOperationBCI/SuiviOperationBCI';
import SuiviOperationBCIV2 from './pages/SuiviOperationBCIV2/SuiviOperationBCIV2';
// LEGACY NEUTRALISE : import SuiviDeCommandesBC from './pages/SuiviDeCommandeBC/SuiviDeCommandeBC';
import SuiviDeCommandeBCV2 from './pages/SuiviDeCommandeBCV2/SuiviDeCommandeBCV2';
import SuiviDeCommandeMSV2 from './pages/SuiviDeCommandeMSV2/SuiviDeCommandeMSV2';
// LEGACY NEUTRALISE : import SuiviDeCommandesBCI from './pages/SuiviDeCommandeBCI/SuiviDeCommandeBCI';
import SuiviDeCommandeBCIV2 from './pages/SuiviDeCommandeBCIV2/SuiviDeCommandeBCIV2';
import Operation from './pages/Operation/Operation';
import Annuaire from './pages/Annuaire/Annuaire';
import FicheContact from './pages/FicheContact/FicheContact';
// FRONT-05: Page Profil unifiee avec routage intelligent
import ProfilRouter from './pages/Profil/ProfilRouter';
import Catalogue from './pages/Catalogue/Catalogue';
import Chiffrage from './pages/Chiffrage/Chiffrage';
import Assistance from './pages/Assistance/Assistance';
import Mentions from './pages/Mentions/Mentions';
import Publications from './pages/Publications/Publications';
import DetailCandidature from './pages/Publications/components/DetailCandidature/DetailCandidature';
import InformationsAC from './pages/Publications/InformationsAC/InformationsAC';
import DemoDetailCandidature from './pages/Publications/components/DemoDetailCandidature/DemoDetailCandidature';
import Documents from './pages/Documents/Documents';
import VerifyEmail from './pages/VerifyEmail/VerifyEmail';
import VerifyEmailSend from './pages/VerifyEmailSend/VerifyEmailSend';
import CG from './pages/CG/CG';
import { Verify } from 'crypto';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import CommandesArchive from './pages/CommandesArchive/CommandesArchive';
import TicketPage from './pages/Ticket/Ticket';
import ErrorBoundary from './composants/ErrorBoundary/ErrorBoundary';
import { NotFound, AccesRefuse, SessionExpiree, MaintenanceApp } from './pages/Erreurs/Erreurs';

function App() {
  // Préchargement des images de lots depuis l'API Core (une seule fois, best-effort)
  preloadLotImages();

  return (
    <AuthProvider>
      <ToastProvider>
      <DocumentsProvider>
        <NotificationsProvider>
          <ProfileProvider>
            <AcheteurProfileProvider>
              <div className="App">
                <main className="content">
                  <ErrorBoundary>
                  <Routes>

                    {/* --- Routes publiques --- */}
                    <Route path="/cgv" element={<CG />} />
                    <Route path="/documents-mobile" element={<Documents />} />
                    <Route path="/verify-email" element={<VerifyEmail />} />
                    <Route path="/verify-email-send" element={<VerifyEmailSend />} />
                    <Route path='/reset-password' element={<ResetPassword />} />


                    <Route element={<MainLayout />}>
                      <Route path="/" element={<Accueil />} />
                      <Route path="/securite" element={<PageStatique slug="politique-securite" />} />
                      <Route path="/mentions-legales" element={<PageStatique slug="mentions-legales" />} />
                      <Route path="/charte-rse" element={<PageStatique slug="charte-rse" />} />
                      <Route path="/charte-deontologie" element={<PageStatique slug="charte-deontologie" />} />
                      <Route path="/charte-achats" element={<PageStatique slug="charte-achat-durable" />} />
                      {/* CGV avec header + footer (depuis le footer). /cgv reste nu pour l'iframe scroll-to-accept de l'inscription. Meme contenu back (slug conditions-generales). */}
                      <Route path="/cg" element={<CG />} />
                      <Route path="/assistance" element={<Assistance />} />
                      <Route path="/mentions" element={<Mentions />} />
                      <Route path="/annuaire" element={<Annuaire hideTitle />} />
                      <Route path="/login" element={<Login />} />
                      <Route path="/register" element={<Register />} />
                      <Route path="/forgot-password" element={<ForgotPassword />} />


                      {/* --- Routes protégées --- */}
                      <Route element={<PrivateRoute />}>

                        {/* Commandes : reserve aux prestataires sous contrat -> un libre est renvoye a /profil */}
                        <Route element={<RequireContractPrestataire />}>
                          <Route path="/commandes" element={<Commandes />} />
                        </Route>
                        <Route path="/commande-ms/:id" element={<SuiviDeCommandeMSV2 />} />
                        {/* Refonte V2 presta x MS LIVE ; ancienne version conservee en rollback ci-dessous */}
                        {/* LEGACY NEUTRALISE (verif avant suppression V2 — decommenter ligne+import pour rollback) */}
                        {/* <Route path="commande-ms-old/:id" element={<SuiviDeCommande />} /> */}
                        <Route path="commande-ms-v2/:id" element={<SuiviDeCommandeMSV2 />} />
                        <Route path="/operations" element={<Operation />} />
                        <Route path="/catalogue" element={<Catalogue />} />
                        <Route path="/chiffrage" element={<Chiffrage />} />
                        <Route path="/operation-ms/:id" element={<SuiviOperationMSV2 />} />
                        {/* Ancienne version conservee pour rollback : revenir a SuiviOperation si besoin */}
                        {/* LEGACY NEUTRALISE : <Route path="operation-ms-old/:id" element={<SuiviOperation />} /> */}
                        <Route path="operation-ms-v2/:id" element={<SuiviOperationMSV2 />} />
                        <Route path="operation-bc/:id" element={<SuiviOperationBCV2 />} />
                        {/* Ancienne version conservee pour rollback : changer la route ci-dessus si besoin */}
                        {/* LEGACY NEUTRALISE : <Route path="operation-bc-old/:id" element={<SuiviOperationBC />} /> */}
                        {/* Refonte V2 presta x BC LIVE ; ancienne version conservee en rollback ci-dessous */}
                        <Route path="commande-bc/:id" element={<SuiviDeCommandeBCV2 />} />
                        {/* LEGACY NEUTRALISE : <Route path="commande-bc-old/:id" element={<SuiviDeCommandesBC />} /> */}
                        <Route path="commande-bc-v2/:id" element={<SuiviDeCommandeBCV2 />} />
                        {/* Refonte V2 presta x BCI LIVE ; ancienne version (V1) conservee en rollback ci-dessous. */}
                        <Route path="commande-bci/:id" element={<SuiviDeCommandeBCIV2 />} />
                        {/* LEGACY NEUTRALISE : <Route path="commande-bci-old/:id" element={<SuiviDeCommandesBCI />} /> */}
                        <Route path="commande-bci-v2/:id" element={<SuiviDeCommandeBCIV2 />} />
                        {/* Refonte V2 acheteur x BCI LIVE ; ancienne version (V1) conservee en rollback ci-dessous. */}
                        <Route path="operation-bci/:id" element={<SuiviOperationBCIV2 />} />
                        {/* LEGACY NEUTRALISE : <Route path="operation-bci-old/:id" element={<SuiviOperationBCI />} /> */}
                        <Route path="operation-bci-v2/:id" element={<SuiviOperationBCIV2 />} />
                        {/* <Route path="/commandes-archive" element={<CommandesArchive />} /> */}
                        <Route path="/contact/:id" element={<FicheContact />} />
                        {/* FRONT-05: Page Profil avec routage intelligent selon le role */}
                        <Route path="/profil" element={<ProfilRouter />} />
                        {/* Redirect ancien URL pour compatibilite */}
                        <Route path="/profil-prestataire" element={<Navigate to="/profil" replace />} />
                        <Route path="/ticket/:id" element={<TicketPage />} />
                        {/* EPIC-DEMO — Candidature fictive : reservee aux prestataires connectes */}
                        <Route path="/publications/ac27/demo" element={<DemoDetailCandidature />} />
                      </Route>

                      {/* --- Routes semi-publiques (accessibles sans connexion) --- */}
                      <Route path="/publications" element={<Publications />} />
                      {/* Story 9.0 — L'ancienne page DashboardCandidatures est remplacée par l'onglet "Mes candidatures" */}
                      <Route path="/publications/ac27" element={<Navigate to="/publications?tab=4" replace />} />
                      <Route path="/publications/ac27/candidatures/:id" element={<DetailCandidature />} />
                      {/* Consultation d'un AC : publique, comme la liste des publications */}
                      <Route path="/publications/ac27/:id/informations" element={<InformationsAC />} />
                    </Route>

                    {/* --- Pages d'etat / erreur (standalone, hors MainLayout) --- */}
                    <Route path="/maintenance" element={<MaintenanceApp />} />
                    <Route path="/acces-refuse" element={<AccesRefuse />} />
                    <Route path="/session-expiree" element={<SessionExpiree />} />
                    {/* Catch-all : 404 pour toute route inconnue */}
                    <Route path="*" element={<NotFound />} />

                  </Routes>
                  </ErrorBoundary>
                </main>
              </div>
            </AcheteurProfileProvider>
          </ProfileProvider>
        </NotificationsProvider>
      </DocumentsProvider>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;